import GenericNewCategoryPage from './GenericNewCategoryPage';

function HiddenGems() {
  return <GenericNewCategoryPage categoryId={14} categoryKey="hiddenGems" />;
}

export default HiddenGems;
